import React from 'react'
import {  Container } from 'react-bootstrap'
import Myworks from './AllChildPages/Myworks/Myworks'



function MyWork() {
    return (
        <div style={{backgroundColor:'#BC3C71',
        paddingTop:'10px'
        }}>
          <Container>
          <h1 className={'text-center'}>Welcome </h1>

          <Myworks></Myworks>



          </Container>
          <br/>  <br/>  <br/>  <br/>  <br/>
        </div>
    )
}

export default MyWork
